import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfessionalServiceTypeService } from '@adeo/ngx-kozikaza-api/pro/service';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable()
export class ServiceTypesResolver  {

  constructor(
    private professionalServiceTypeService: ProfessionalServiceTypeService
  ) {
  }

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<any> {
    return this.professionalServiceTypeService.getProfessionalServiceTypes().pipe(
      switchMap((data) => {
        return of(data['hydra:member']);
      })
    );
  }
}
